import { FlightInfo } from '@lt/api/dist/methods/packages/types';
import { get } from 'lodash';
import { useWidgetData } from '../../../context/widgetDataContext';
import { PackageContextState } from '../types';

export const useGetFlights = () => {
  const { data } = useWidgetData<undefined | PackageContextState>();

  const flight: FlightInfo | undefined = get(data, ['flight_option']);

  const flightsTo = flight?.to;
  const flightsBack = flight?.back;

  return {
    flightsCount: data?.moreFlightsOptionsCount || 0,
    flightsTo,
    flightsBack,
    flight,
  };
};
